import React, { useState, useRef, useEffect } from "react";
import clsx from "clsx";
import _ from 'lodash';
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import URL from "../../../../constant/URL";
import TYPE from "../../../../constant/TYPE";
import useLaTexCode from "../../../../hooks/useLaTexCode";
import Button from "../../../common/Button";
import Tip from "./Tip";
import Grammar from "../Grammar";
import CheckWrongAnsertMultipleChoiceQuestion from "../../../answeringQuestions/learning/presentational/body/input/multipleChoiceQuestionKeypad/CheckWrongAnsertMultipleChoiceQuestion";
import MultipleChoiceQuestionKeypad from "../../../answeringQuestions/learning/presentational/body/input/multipleChoiceQuestionKeypad/MultipleChoiceQuestionKeypad";

const View = ( props ) => {

  const [ exercise, setExercise ] = useState( [] );
  const [ answer, setAnswer ] = useState( [] );
  const [ userAnswer, setUserAnswer ] = useState( [] );
  const [ isShowTip, setIsShowTip ] = useState( false );
  const [ isShowAnswer, setIsShowAnswer ] = useState( false );

  const isAnswer = useRef( [] );

  const history = useHistory();
  const { t } = useTranslation();
  const { getEndScope } = useLaTexCode();
  const data = props.data[props.currentIndex] || {};

  useEffect( () => {
    if ( data.qstCd && data.qstCn ) {
      const mapExercise = ( value, index, origin ) => {
        const cssId = `${ TYPE.ID.ANSWER_AREA }${ index }}{`;
        if ( index ) {
          const scopeStartValue = value.slice( value.indexOf( '{' ) );
          const scopeEndPoint = getEndScope( scopeStartValue );
          return `${ scopeStartValue.slice( scopeEndPoint - 1 ) }${ origin.length === index + 1 ? '' : cssId }`;
        } else {
          return `${ value }${ cssId }`;
        }
      };
      const replaceBrokenCode = ( value ) => {
        if ( -1 < value.indexOf( 'leqft' ) ) {
          return value.split( 'leqft' ).join( 'left' );
        } else {
          return value;
        }
      };
      if (data.qstCn.indexOf('inputArea') > -1 ) {
        setExercise(data.qstCn.split('inputArea').map(mapExercise));
      } else {
        setExercise([data.qstCn])
      }

      
      const answer = data.qstCransr.split( ';' );
      let userAnswer = []

      if (data.objctYn === 'Y') {
        data.qstCransr.split(';').forEach((item) => {
          userAnswer.push(`\\phantom{${item}}`)
        });
      } else {
        userAnswer = data.mbrAnsr.split(';').map(replaceBrokenCode);
      }
      // console.log({ qstCn: data.qstCn, answer, userAnswer, mbrAnsr: data.mbrAnsr });

      setAnswer(answer);
      setUserAnswer(userAnswer);
      
      
      switch ( data.cransrTyScnCd ) {
        case TYPE.ANSWER.ORDER :
          isAnswer.current = userAnswer.map( ( v, i ) => answer[ i ] === v );
          break;
        case TYPE.ANSWER.NO_ORDER :
          let reducingAnswer = [ ...answer ];
          const mapIsWrongAnswerForNoOrder = ( value ) => {
            const answerIndex = reducingAnswer.map( ( v, i ) => value === v && i ).filter( v => false !== v );
            if ( answerIndex.length ) {
              reducingAnswer = reducingAnswer.filter( ( v, i ) => answerIndex[ 0 ] !== i );
            }
            return !! answerIndex.length;
          };
          isAnswer.current = userAnswer.map( mapIsWrongAnswerForNoOrder );
          break;
        case TYPE.ANSWER.EITHER :
          isAnswer.current = [ !! answer.filter( v => data.mbrAnsr === v ).length ];
          break;
      }
    }
  }, [ data.qstCd, data.rgtnDt ] );

  const showTip = () => {
    setIsShowTip( ! isShowTip );
  };

  const answering = () => {
    console.log("***** 오답확인 페이지 -> 다시풀기")

    // 닫힌 문제 제외
    const choiceQstCd = props.data[props.currentIndex].qstCd;
    const choiceRgtnDt = props.data[props.currentIndex].rgtnDt;
    const data = _.filter(props.data, (o) => o.qstOpenYn === 'Y');
    const index = _.findIndex(data, (o) => o.rgtnDt === choiceRgtnDt);

    history.push({ 
      pathname : URL.LEARNING.RE_ANSWERING, 
      state: { data, choiceQstCd, index } 
    });
  };

  const showAnswer = () => {
    setIsShowAnswer(!isShowAnswer);
  };

  return (
    <div className="wa-body">
      <div className="wa-cont-wrap">
        <div className="wa-cont-headwrap">
          <div className="wa-cont_head">
            <div className="txt-q">
              <p>{ `Q. ${ data.textCn || '' }` }</p>
            </div>
            <div className="wa-btnbox epnPopup-wrap">
              <div className="flt_rgt">
                { data.explCn && <Button className={ clsx( 'btn_epn', 'btn-viewopen', isShowTip ? 'on' : 'off' ) } onClick={ showTip }>{ t( 'LC_05_13.msg005' ) }</Button> }
                {data.qstOpenYn === 'Y' && <Button className="btn_redo off" onClick={ answering }>{ t( 'LC_05_13.msg006' ) }</Button> }
                <Button className={ clsx( 'btn_chansr', isShowAnswer ? 'on' : 'off' ) } onClick={ showAnswer }>{ t( 'LC_05_13.msg002' ) }</Button>
              </div>
              {(isShowTip && data.explCn) && <Tip showTip={showTip}>{ data.explCn }</Tip> }
            </div>
          </div>
        </div>
        <div 
          className={
            clsx(
              "wa-cont-body",
              data.objctYn === 'Y' && 'multiple'
            )
          }
        >
          <div className="wa-cont">
            <div className="wa-cont-inner">
              <div className={`wa-container ${isShowAnswer ? 'wa-correct' : 'wa-wrong' }` }>
                <Grammar data={ data }>
                  { 
                    exercise.map( ( v, i, o ) => {
                      return (
                        o.length === i + 1
                          ? v 
                          : `${v}${isShowAnswer && data.objctYn === 'N' ? answer[i] : userAnswer[i]}`
                      )
                    }).join( '' ) 
                  }
                </Grammar>
              </div>
            </div>
          </div>
          <div className="wa-answer-box">
          {
            (data.objctYn === 'Y' && !_.isEmpty(data)) && (
              <CheckWrongAnsertMultipleChoiceQuestion 
                data={data}
              >
                <MultipleChoiceQuestionKeypad 
                  isShowAnswer={isShowAnswer}
                />
              </CheckWrongAnsertMultipleChoiceQuestion>
            )
          }
          </div>
          <div className="wa-cont-foot">
            { 'Y' === data.corPsbleQstYn && <Button>{ t( 'LC_05_13.msg003' ) }</Button> }
            { 'Y' === data.drilldwQstYn && <Button>{ t( 'LC_05_13.msg004' ) }</Button> }
          </div>
        </div>
      </div>
    </div>
  );

};

export default View;
